import { Modal, Stack } from 'src/components';
import styled, { css } from 'styled-components';

export const Content = styled(Stack)<{ $isFullSize: boolean }>(
  ({ theme, $isFullSize }) => css`
    background: ${theme.co.neutral99};
    padding: ${theme.sz.s10};
    min-height: ${$isFullSize && '100%'};
    @media (max-width: ${theme.sz.md}) {
      padding: ${theme.sz.s10} ${theme.sz.s4};
    }
  `,
);

export const Header = styled.h1(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.m};
    text-align: center;

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.heading.mobile.m};
    }
  `,
);

export const Description = styled.span(
  ({ theme }) => css`
    color: ${theme.co.neutral0};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.s};
    }
  `,
);

export const Subtitle = styled.h3(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxs};
    display: inline-flex;
    align-items: baseline;
    color: ${theme.co.secondary0};
    margin: ${theme.sz.s6} 0 0 0;
    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.heading.mobile.xxs};
    }
  `,
);

export const BodyContainer = styled.div(
  ({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;
    text-align: center;
    margin: 0;
    gap: ${theme.sz.s6};
    @media (max-width: ${theme.sz.md}) {
      gap: ${theme.sz.s4};
    }
  `,
);

export const TopButtons = styled.div(
  () => css`
    display: flex;
    flex-direction: column;
    width: 100%;
  `,
);

export const ModalWrapper = styled(Modal)(
  ({ theme }) => css`
    .reactModalContent {
      min-width: ${theme.sz.lg};

      @media (max-width: ${theme.sz.lg}) {
        min-width: 0;
      }
    }
  `,
);

export const StreakText = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.s};
    display: inherit;
    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.heading.mobile.s};
    }
  `,
);

export const Number = styled.div(
  ({ theme }) => css`
    padding-right: ${theme.sz.s1};
  `,
);

export const Colon = styled.div(
  ({ theme }) => css`
    padding-right: ${theme.sz.s4};
  `,
);

export const AnimationContainer = styled.div(
  ({ theme }) => css`
    width: ${theme.sz.s48};
    @media (max-width: ${theme.sz.md}) {
      width: ${theme.sz.s32};
    }
  `,
);
